import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IoniconsOutline} from '@pt/pt-models';

@Component({
  selector: 'pt-pdf-action',
  template: `
    <div class='pdf-info'>
      <div class='pages'>
        {{ 'LABELS.PAGE' | translate }} {{ currentPage }} / {{ totalPage }}
      </div>
      <div class='zoom'>
        <label class='d-inline-flex btn btn-link text-white '
               [ngClass]='[!disabledZoomDown ? "cursor-pointer" : ""]'
               (click)='!disabledZoomDown ? zoomDown.emit() : null'>
          <pt-icon [key]='IconRemove' [size]='20'></pt-icon>
        </label>

        <label class='d-inline-flex btn btn-link text-white p-0 mx-2'
               (click)='zoomMax.emit()'>
          <pt-icon [key]='IconSearch' [size]='18'></pt-icon>
        </label>

        <label class='d-inline-flex btn btn-link text-white'
               [ngClass]='[!disabledZoomUp ? "cursor-pointer" : ""]'
               (click)='!disabledZoomUp ? zoomUp.emit(): null'>
          <pt-icon [key]='IconAdd' [size]='20'></pt-icon>
        </label>
      </div>
    </div>
  `,
  styles: [`
    .pdf-info {
      height: 25px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .pdf-info .pages {
      width: 150px;
      align-items: center;
      justify-content: center;
      display: flex;
      height: 100%;
      border-right: 1px solid #dbdbdb;
    }

    .pdf-info .zoom {
      width: 150px;
      height: 100%;
      justify-content: center;
      align-items: center;
      display: flex;
      font-size: 14px;
    }

    .zoom label {
      margin: 0;
      padding: 0;
    }

    .zoom label:active {
      color: grey !important;
    }
  `]
})
export class PdfActionComponent {

  @Input() disabledZoomDown: boolean;

  @Input() currentPage: number;

  @Input() totalPage: number;

  @Input() disabledZoomUp: boolean;


  @Output() zoomMax = new EventEmitter();
  @Output() zoomDown = new EventEmitter();
  @Output() zoomUp = new EventEmitter();

  IconAdd = IoniconsOutline.plus;
  IconRemove = IoniconsOutline.minus;
  IconSearch = IoniconsOutline.search;
}
